import { useState } from 'react'
import toast from 'react-hot-toast'
import Modal from '../../ui/Modal'
import { deliveriesAPI } from '../../../api/deliveries'

const textareaStyle: React.CSSProperties = {
  width: '100%', padding: '12px 14px',
  borderRadius: 12, border: '1.5px solid #E5E7EB',
  fontSize: 14, fontFamily: "'DM Sans', sans-serif",
  resize: 'vertical', outline: 'none',
  background: '#FAFAFA', color: '#0D1117',
  boxSizing: 'border-box',
}

const btnStyle: React.CSSProperties = {
  display: 'flex', alignItems: 'center', gap: 8,
  border: 'none', borderRadius: 12,
  padding: '12px 20px', color: '#fff',
  fontSize: 14, fontWeight: 600,
  cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
  flex: 1, justifyContent: 'center',
}

interface InjoinableModalProps {
  deliveryId: string
  onClose: () => void
  onSuccess: () => void
}

export const InjoinableModal = ({ deliveryId, onClose, onSuccess }: InjoinableModalProps) => {
  const [attempts, setAttempts] = useState('1')
  const [comment, setComment] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async () => {
    setIsLoading(true)
    try {
      const note = `Client injoinable après ${attempts} tentative(s) d'appel.${comment ? ' ' + comment : ''}`
      await deliveriesAPI.updateStatus(deliveryId, {
        status: 'unreachable',
        comment: note,
      })
      toast.success('Colis marqué client injoinable')
      onSuccess()
      onClose()
    } catch {
      toast.error('Erreur lors de la mise à jour')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal open title="Client injoinable" onClose={onClose} size="sm">
      <p style={{ color: '#6B7280', fontSize: 13, marginBottom: 16, marginTop: 0 }}>
        Le colis sera marqué "Injoinable". L'admin sera informé pour replanifier la livraison.
      </p>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>
          Nombre de tentatives d'appel
        </label>
        <div style={{ display: 'flex', gap: 8 }}>
          {['1', '2', '3', '3+'].map((n) => (
            <button
              key={n}
              onClick={() => setAttempts(n)}
              style={{
                padding: '8px 16px', borderRadius: 8,
                border: `2px solid ${attempts === n ? '#8B5CF6' : '#E5E7EB'}`,
                background: attempts === n ? '#F5F3FF' : '#fff',
                color: attempts === n ? '#8B5CF6' : '#374151',
                fontWeight: 600, cursor: 'pointer', fontSize: 14,
              }}
            >
              {n}
            </button>
          ))}
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>
          Commentaire (optionnel)
        </label>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Ex : Le téléphone sonne mais personne ne répond..."
          rows={3} maxLength={300}
          style={textareaStyle}
        />
      </div>

      <div style={{ display: 'flex', gap: 10 }}>
        <button onClick={onClose} style={{ ...btnStyle, background: '#F3F4F6', color: '#374151' }}>
          Annuler
        </button>
        <button
          onClick={handleSubmit}
          disabled={isLoading}
          style={{ ...btnStyle, background: '#8B5CF6', opacity: isLoading ? 0.7 : 1, cursor: isLoading ? 'not-allowed' : 'pointer' }}
        >
          {isLoading ? 'Envoi...' : 'Confirmer — Client injoinable'}
        </button>
      </div>
    </Modal>
  )
}
